import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldAlert } from "lucide-react";

// Warning banner shown across owner pages when the subscription needs attention.
export function SubscriptionBanner() {
  const [sub, setSub] = useState(null);
  useEffect(() => {
    api.get("/owner/subscription").then((r) => setSub(r.data)).catch(() => {});
  }, []);

  if (!sub || (sub.status !== "past_due" && sub.status !== "expired")) return null;

  const expired = sub.status === "expired";
  return (
    <div className={`${expired ? "bg-[#8C3131]/15 border-[#8C3131]/40 text-[#E08D8D]" : "bg-[#C5A059]/10 border-[#C5A059]/40 text-[#C5A059]"} border-b`} data-testid="subscription-banner">
      <div className="max-w-7xl mx-auto px-6 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-sm">
        <span className="inline-flex items-center gap-2">
          <ShieldAlert className="w-4 h-4 shrink-0" strokeWidth={1.5} />
          {expired
            ? "Votre abonnement a expiré — votre espace et votre site sont suspendus."
            : `Paiement en retard${sub.days_remaining != null ? `, échéance dépassée` : ""}. Réglez pour éviter la suspension.`}
        </span>
        <Link to="/dashboard/billing" className="underline uppercase tracking-[0.15em] text-xs whitespace-nowrap" data-testid="subscription-banner-link">
          Régler mon abonnement →
        </Link>
      </div>
    </div>
  );
}
